import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

// Register the components Chart.js needs to draw a line chart
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export function ProgressChart({ progressData }) {
  // Extract the months for the chart's X-axis labels
  const labels = progressData.map(d => d.month);

  // Calculate the KDA for each month
  const kdaData = progressData.map(d => {
    const deaths = d.TotalDeaths === 0 ? 1 : d.TotalDeaths; // Avoid division by zero
    return ((d.TotalKills + d.TotalAssists) / deaths).toFixed(2);
  });

  // Calculate the Win Rate for each month
  const winRateData = progressData.map(d => 
    ((d.TotalWins / d.GamesPlayed) * 100).toFixed(1)
  );

  const data = {
    labels,
    datasets: [
      {
        label: 'Monthly KDA Ratio',
        data: kdaData,
        borderColor: '#F59E0B', // A mystical gold color
        backgroundColor: 'rgba(245, 158, 11, 0.5)',
        yAxisID: 'y', // Link to the left Y-axis
      },
      {
        label: 'Monthly Win Rate (%)',
        data: winRateData,
        borderColor: '#06B6D4', // A mystical cyan color
        backgroundColor: 'rgba(6, 182, 212, 0.5)',
        yAxisID: 'y1', // Link to the right Y-axis
      },
    ],
  };

  const options = {
    responsive: true,
    interaction: {
      mode: 'index',
      intersect: false,
    },
    plugins: {
      legend: {
        labels: { color: '#e0e0e0' }
      },
      title: {
        display: true,
        text: 'Player Performance Over Time',
        color: '#e0e0e0',
        font: { size: 18 }
      },
    },
    scales: {
      x: { 
        ticks: { color: '#e0e0e0' },
        grid: { color: 'rgba(224, 224, 224, 0.1)' }
      },
      y: { // Left axis for KDA
        type: 'linear',
        display: true,
        position: 'left',
        title: { text: 'KDA Ratio', display: true, color: '#F59E0B' },
        ticks: { color: '#e0e0e0' },
        grid: { color: 'rgba(224, 224, 224, 0.2)' },
      },
      y1: { // Right axis for Win Rate
        type: 'linear',
        display: true,
        position: 'right',
        title: { text: 'Win Rate (%)', display: true, color: '#06B6D4' },
        ticks: { color: '#e0e0e0' },
        grid: { drawOnChartArea: false }, // Only show the main grid lines from the left axis
      },
    },
  };

  return <Line options={options} data={data} />;
}